var _RESOURCES;
function __Resources() {
    this._JS_Com = function () {
        this.close_lbl = 'schliessen';
        this.cancel_lbl = 'Abbrechen';
        this.chooseColor_lbl = 'Wählen Sie eine Farbe';
        this.ERR_noTaskEntered_lbl = 'Es wurde kein Task eingegeben!';
        this.ERR_sortNotSaved_lbl = 'FEHLER - Die Sortierung konnte nicht gespeichert werden!';
        this.ERR_taskNotDeleted_lbl = 'Der Task konnte nicht gelöscht werden!';
        this.ERR_taskNotSaved_lbl = 'Der Task konnte nicht eingetragen werden!';
        this.loading_lbl = 'lädt ...';
        this.new_lbl = 'Neu';
        this.OK_lbl = 'OK';
        this.ERR_invalidDate_lbl = 'Es wurde ein ungültiges Datum eingegeben - bitte überprüfen Sie Ihre Eingabe!';
        this.ERR_invalidTime_lbl = 'Es wurde eine ungültige Zeit eingegeben - bitte überprüfen Sie Ihre Eingabe!';
        this.ERR_greaterNumber_inc = 'Bitte geben Sie eine Zahl größer';
        this.ERR_input_inc = 'ein!';
        this.ERR_lowerNumber_inc = 'Bitte geben Sie eine Zahl kleiner';
        this.ERR_maxInput_inc = 'Geben Sie bitte maximal';
        this.ERR_minInput_inc = 'Geben Sie bitte mind.';
        this.ERR_missingField_lbl = 'Bitte füllen Sie dieses Feld aus!';
        this.ERR_signs_inc = 'Zeichen ein!';
        this.ERR_validEmail_lbl = 'Bitte geben Sie eine gültige Email-Adr. ein!';
        this.ERR_validNumber_lbl = 'Bitte geben Sie eine gültige Zahl ein!';
        this.ERR_validTelephone_lbl = 'Bitte geben Sie eine gültige Tel-Nr. ohne vorangehende 0 ein!';
        this.ERR_validURL_lbl = 'Bitte geben Sie eine gültige Url ein!';
        this.ERR_noTextInserted_lbl = 'ACHTUNG - Es wurde noch kein Text eingegeben!';
        this.noEntry_lbl = 'kein Eintrag';
        this.dataTransferSuccessfull_lbl = 'Bei der Datenübernahme ist ein Fehler aufgetreten!';
        this.roomSuccessfullyAdapted_lbl = 'Die Zimmer wurden erfolgreich umgestellt!';
        this.ERR_wrongSettings_lbl = 'Die Einstellungen sind leider ungültig - bitte überprüfen Sie Ihre Eingabe!';
        this.signalSelection_lbl = 'Signalauswahl';
        this.noMedia = 'Das gewählte Medium existiert nicht';
        this.noMediaDetails = 'Keine Details vorhanden';
        this.tip_mediaChange = 'Ändern';
        this.tip_removeAssignment = 'Zuordnung lösen';
        this.filterSelection_lbl = 'Filterauswahl';
        this.filterType_lbl = 'Filterart';
        this.selectedAndOwnFilter_lbl = 'ausgewählte/eigene Filter';
        this.and_lbl = 'und';
        this.or_lbl = 'oder';
        this.showAll_lbl = 'alles anzeigen';
        this.editTags_lbl = 'Schlagwörter-Verwaltung';
        this.assignTags2Signals_lbl = 'Schlagwörter-Zuordnung zu Signalen';
        this.assignSignals2Tags_lbl = 'Signalzuordnung zu Schlagwörter';
        this.tagManagerHelp0_lbl = 'Hiermit können Sie beliebige Signale einem Schlagwort zuweisen - <u>Doppelklicken Sie auf ein Signal, um es zuzuweisen bzw. zu entfernen</u>!';
        this.tagManagerHelp1_lbl ='Hiermit können Sie beliebige Schlagwörter einem Signal zuweisen - <u>Doppelklicken Sie auf ein Schlagwort, um es zuzuweisen bzw. zu entfernen</u>!';
        this.tagManagerHelp2_lbl = 'Hier können Sie Schlagwörter verwalten! Werden Schlagwörter geändert, wird danach das Menü und die Signalliste neu geladen!';
        this.mainMenu_lbl = 'Hauptmenü';
        this.withoutTags_lbl = 'ohne Schlagwörter';


        this.selection = "Auswahl";
        this.status = "Status";
        this.err_sub = "Bitte laden Sie die Seite neu! Tritt der Fehler weiterhin auf, melden Sie dies bitte dem Support!";
        this.err_code = "Es ist ein Anwendungsfehler aufgetreten!";
        this.err_loadData = "Beim Laden der Daten ist ein Fehler aufgetreten!";
        this.err_saveData = "Die Daten konnten nicht gespeichert werden!";
        this.noEntriesExist = "Es sind keine Einträge vorhanden!";
        this.dialogTitle = "Validierung";
        this.yes = "Ja";
        this.no = "Nein";
        this.cleanHtmlCaption = "Es wurde unzulässiger Text erkannt - bitte bereinigen Sie Ihn, indem Sie ihn zuerst in dieses Textfeld kopieren!";
        this.cleanHtmlBtnYes = "bereinigten Text kopieren";
       

    };
    this.JS_Com = new this._JS_Com();




}
$(document).ready(function () {
    _RESOURCES = new __Resources();
});